export default function isSelectionInLastTableCell(editor) {
  var tableId = editor.getCurrentTableId();
  var cells = editor.getTableCells(tableId);
  return cells.last() === editor.value.endBlock || cells.last() === editor.value.startBlock;
}